import { AxiosInstance, AxiosResponse } from 'axios';
import { AxiosClient, AxiosUtils } from 'api/AxiosClient/AxiosClient';
import { config } from 'config';
import * as Sentry from '@sentry/react';
import { InvalidRegionCodeError, SERVICE_DOWN } from 'api/errors';
import { ValidationResponse } from 'types';

class NormalizedValidation {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_NORMALIZED_VALIDATION,
    });
  }

  public async validatePhoneNumber(phoneNumber: string): Promise<ValidationResponse> {
    return this.client
      .post<ValidationResponse>(
        'phoneNumber/validate',
        {
          phoneNumber,
        },
        {
          headers: AxiosClient.getAuthorizationHeader(),
        },
      )
      .then(r => {
        const data: ValidationResponse = r.data;
        if (data.regionCode !== 'FR' && data.regionCode !== 'MC') {
          return Promise.reject(new InvalidRegionCodeError());
        }
        return data;
      })
      .catch(r => {
        if (r instanceof InvalidRegionCodeError) {
          return Promise.reject({ message: r.message });
        } else {
          Sentry.captureException(r, {
            tags: {
              api: 'Normalized-validation',
              endpoint: 'phoneNumber/validate',
              ...AxiosUtils.enrichTags(r),
            },
          });
          if (r.response) {
            const response: AxiosResponse = r.response;
            return Promise.reject(response.data);
          }
        }
        return Promise.reject({ message: SERVICE_DOWN });
      });
  }
}

export const NormalizedValidationService = new NormalizedValidation();
